import React, { Component, useState, useEffect } from 'react';
import {connect} from 'react-redux';

import { Typography, Grid, Box, Container } from '@material-ui/core';

import TitleText from './components/TitleText';
import KontenText from './components/KontenText';
import Garis from './components/Garis';
import RenderChart from './components/RenderChart';

import Footer from './components/Footer';
import GrafikBarTegak from './components/GrafikBarTegak'
import './styleDinas.css';
import KontenTextImage from './components/KontenTextImage';

class DinasJatim_3_4 extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }

    componentDidMount(){
    }
    

    render() { 

        return (
            <Grid 
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="stretch"
                spacing={2}>
                <Grid item>
                    <KontenTextImage logo={'/image/dinas/header-stat-prov.png'} title={'statistik provinsi'} subTitle={'Provinsi Jawa Timur'}/>
                </Grid>
                
                <Grid item xs={12} style={{padding: 20, background: '#bdbdb924'}}>                    
                    <Grid 
                        spacing={2}
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="stretch"
                        >                 
                            <Grid item xs={3} style={{alignSelf: 'center'}}>
                                <Typography variant="body1" color="textPrimary" style={{fontWeight: 700}}>Bahasa Indonesia</Typography>
                            </Grid>
                            <Grid item>
                                <GrafikBarTegak value={15} color={'#C68B59'} label={'Terendah'}/>
                            </Grid> 
                            <Grid item>
                                <GrafikBarTegak value={20} color={'#00C1D4'} label={'Kuartil 1'}/>
                            </Grid> 
                            <Grid item>
                                <GrafikBarTegak value={30} color={'#50CB93'} label={'Median'}/>
                            </Grid> 
                            <Grid item>
                                <GrafikBarTegak value={40} color={'#7952B3'} label={'Rata-rata'}/>
                            </Grid> 
                            <Grid item>
                                <GrafikBarTegak value={55} color={'#FF3F00'} label={'Kuartil 3'}/>
                            </Grid> 
                            <Grid item>
                                <GrafikBarTegak value={55} color={'#EBA83A'} label={'Tertinggi'}/>
                            </Grid> 
                            <Grid item>
                                <GrafikBarTegak value={84} color={'#FD6F96'} label={'Standar Deviasi'}/>
                            </Grid> 
                    </Grid>                    
                </Grid>

                <Grid item xs={12} align="center">
                    <TitleText title={'TABEL STATISTIK PROVINSI'} subTitle={''} />
                </Grid>

                <Grid item xs={12} align="center">
                    <div className="header-table main-bg-color">
                        <table width="100%" >
                            <thead>
                                <tr>
                                    <th width="3%"></th>
                                    <th>MATA PELAJARAN</th>
                                    <th className="text-center">TERENDAH</th>
                                    <th className="text-center">KUARTIL 1</th>
                                    <th className="text-center">MEDIAN</th>
                                    <th className="text-center">RATA RATA</th>
                                    <th className="text-center">KUARTIL 3</th>
                                    <th className="text-center">TERTINGGI</th>
                                    <th className="text-center">STANDAR DEVIASI</th>
                                    <th width="3%"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td width="3%"></td>
                                    <td>
                                        <div className="text-segitiga">Nama</div>    
                                        <div className="segitiga" />
                                        <hr className="garis-tabel-bottom" />
                                    </td>
                                    <td>
                                        <div className="text-segitiga text-center">sssttt</div>    
                                        <div className="segitiga" />
                                        <hr className="garis-tabel-bottom" />
                                    </td>
                                    <td>
                                        <div className="text-segitiga text-center">sssttt</div>    
                                        <div className="segitiga" />
                                        <hr className="garis-tabel-bottom" />
                                    </td>
                                    <td>
                                        <div className="text-segitiga text-center">sssttt</div>    
                                        <div className="segitiga" />
                                        <hr className="garis-tabel-bottom" />
                                    </td>
                                    <td>
                                        <div className="text-segitiga text-center">sssttt</div>    
                                        <div className="segitiga" />
                                        <hr className="garis-tabel-bottom" />
                                    </td>
                                    <td>
                                        <div className="text-segitiga text-center">sssttt</div>    
                                        <div className="segitiga" />
                                        <hr className="garis-tabel-bottom" />
                                    </td>
                                    <td>
                                        <div className="text-segitiga text-center">sssttt</div>    
                                        <div className="segitiga" />
                                        <hr className="garis-tabel-bottom" />
                                    </td>
                                    <td>
                                        <div className="text-segitiga text-center">sssttt</div>    
                                        <div className="segitiga" />
                                        <hr className="garis-tabel-bottom" />
                                    </td>
                                    <td width="3%"></td>
                                </tr>
                                <tr>
                                    <td width="3%"></td>
                                    <td>
                                        <div className="text-segitiga">Nama</div>    
                                        <div className="segitiga" />
                                        <hr className="garis-tabel-bottom" />
                                    </td>
                                    <td>
                                        <div className="text-segitiga text-center">sssttt</div>    
                                        <div className="segitiga" />
                                        <hr className="garis-tabel-bottom" />
                                    </td>
                                    <td>
                                        <div className="text-segitiga text-center">sssttt</div>    
                                        <div className="segitiga" />
                                        <hr className="garis-tabel-bottom" />
                                    </td>
                                    <td>
                                        <div className="text-segitiga text-center">sssttt</div>    
                                        <div className="segitiga" />
                                        <hr className="garis-tabel-bottom" />
                                    </td>
                                    <td>
                                        <div className="text-segitiga text-center">sssttt</div>    
                                        <div className="segitiga" />
                                        <hr className="garis-tabel-bottom" />
                                    </td>
                                    <td>
                                        <div className="text-segitiga text-center">sssttt</div>    
                                        <div className="segitiga" />
                                        <hr className="garis-tabel-bottom" />
                                    </td>
                                    <td>
                                        <div className="text-segitiga text-center">sssttt</div>    
                                        <div className="segitiga" />
                                        <hr className="garis-tabel-bottom" />
                                    </td>
                                    <td>
                                        <div className="text-segitiga text-center">sssttt</div>    
                                        <div className="segitiga" />
                                        <hr className="garis-tabel-bottom" />
                                    </td>
                                    <td width="3%"></td>
                                </tr>
                            </tbody>
                            
                        </table>
                    </div>
                </Grid>

                
                <div class="component-footer"><Footer halaman={3}/></div>
            </Grid>

        );
    }
}

export default DinasJatim_3_4;